import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, NavLink } from 'react-router-dom';
import { IoMdAdd, IoIosCheckmark, IoIosClose } from 'react-icons/io';
import { familyDetailQuery } from '../utils/data';
import { client } from '../client';
import { fetchUser } from '../utils/FetchUser';
import { v4 as uuidv4 } from 'uuid';
import Spinner from './Spinner';

const activeBtnStyles = 'bg-indigo-500 text-white font-bold p-2 rounded-full w-auto m-1 outline-none';
const notActiveBtnStyles = 'bg-primary text-black font-bold p-2 rounded-full w-auto m-1 outline-none';

const FamilyDetails = ({setView}) => {
    const [family, setFamily] = useState(null);
    const [text, setText] = useState('Created');
    const [activeBtn, setActiveBtn] = useState('created');
    const [postHovered, setPostHovered] = useState(false);

    const navigate = useNavigate();
    const { famId } = useParams();


    const User = fetchUser();

    useEffect(() => {
        const query = familyDetailQuery(famId);
        client.fetch(query).then((data) => {
            setFamily(data[0]);
            setView(data[0].familyName);
        });
    }, [famId]);

    const acceptRequest = (requestUserId) => {
        client
            .patch(famId)
            .setIfMissing({ users: [] })
            .insert('after', 'users[-1]', [{
                _key: uuidv4(),
                _ref: requestUserId,
                _type: 'reference',
            }])
            .commit()
            .then((res) => {
                // client
                // .patch(famId)
                // .unset(['requests[_ref=="' + requestUserId + '"]'])
                // .commit()
                // .then((res) => { 
                //     console.log(res);
                //     navigate(`/family-detail/${famId}`); 
                // })
                denyRequest(requestUserId);
            });
        console.log("request finished");
    }

    const denyRequest = (requestUserId) => {
        console.log("request denied");
        console.log(requestUserId);
        console.log('requests[_ref=="' + requestUserId + '"]')

        client
        .patch(famId)
        .unset(['requests[_ref=="' + requestUserId + '"]'])
        .commit()
        .then((res) => { 
            console.log(res);
            navigate(`/family-detail/${famId}`); 
        });
    }

    if (!family || !family.users) return <Spinner message="Loading profile" />;

    return (
        <div className="relative pb-2 h-full justify-center items-center">
            <div className="flex flex-col pb-5">
                <div className="relative flex flex-col mb-7">
                    <div className="flex flex-col justify-center items-center">
                        <div
                            onMouseEnter={() => setPostHovered(true)}
                            onMouseLeave={() => setPostHovered(false)}
                            // onClick={() => navigate(`/pin-detail/${_id}`)}
                            className=" relative cursor-zoom-in w-auto hover:shadow-lg rounded-lg overflow-hidden transition-all duration-500 ease-in-out"
                        >
                            <img
                                className=" w-full h-100 2xl:h-51 shadow-lg object-cover"
                                src={family?.imageUrl + "?h=200"}
                                alt="user-pic"
                            />

                            {postHovered && (
                                <div
                                    className="absolute top-0 w-full h-full flex flex-col justify-between p-1 pr-2 pt-2 pb-2 z-50"
                                    style={{ height: '100%' }}
                                >
                                    <button>
                                        <IoMdAdd />
                                    </button>
                                </div>
                            )}
                        </div>


                    </div>
                    <h1 className="font-bold text-3xl text-center mt-3">
                        {family?.familyName}
                    </h1>
                    <div className="absolute top-0 z-1 right-0 p-2">
                       
                    </div>
                </div>
                <div className="text-center mb-7">
                    <button
                        type="button"
                        onClick={(e) => {
                            setText(e.target.textContent);
                            setActiveBtn('members');
                        }}
                        className={`${activeBtn === 'members' ? activeBtnStyles : notActiveBtnStyles}`}
                    >
                        Members
                    </button>
                    <button
                        type="button"
                        onClick={(e) => {
                            setText(e.target.textContent);
                            setActiveBtn('setting');
                        }}
                        className={`${activeBtn === 'setting' ? activeBtnStyles : notActiveBtnStyles}`}
                    >
                        Settings
                    </button>
                    {User.sub == family?.admin?._id &&
                        <button
                            type="button"
                            onClick={(e) => {
                                setText(e.target.textContent);
                                setActiveBtn('requests');
                            }}
                            className={`${activeBtn === 'requests' ? activeBtnStyles : notActiveBtnStyles}`}
                        >
                            Requests
                        </button>
                    }
                </div>

                {activeBtn === 'members' &&
                    <>
                        {!family.users ? <Spinner message="Loading profile" /> : <>
                            {family?.users?.map((member) =>
                                <div className='flex-1 gap-2 md:gap-5 w-4/5 h-auto rounded-md mt-5  bg-secondaryColor content-center'>
                                    <NavLink
                                        to={`/user-profile/${member.user[0]?._id}`}
                                        className='flex items-center px-5 gap-3 text-gray-500 hover:text-black transition-all duration-200 ease-in-out capitalize'
                                        key={member?.userName}
                                    >
                                        <img src={member.user[0]?.profUrl + "?h=40"} className="w-8 h-8 rounded-full shadow-sm" />
                                        <h1>{member.user[0]?.userName}</h1>
                                    </NavLink>
                                </div>
                            )}
                        </>}
                    </>
                }
                {activeBtn === 'requests' &&
                    <div className='flex-1 gap-2 md:gap-5 w-4/5 h-auto rounded-md mt-5  bg-secondaryColor content-center'>
                        {family?.requests?.map((member) =>
                            <div className='flex flex-1 gap-2 md:gap-5 w-4/5 h-auto rounded-md mt-5 border-2 bg-secondaryColor content-center'>
                                <NavLink
                                    to={`/Join-family/${family?._id}`}
                                    className='flex items-center px-5 gap-3 text-gray-500 hover:text-black transition-all duration-200 ease-in-out capitalize'
                                    key={member.user[0]?.userName}
                                >
                                    <img src={member.user[0]?.image + "?h=40"} className="w-8 h-8 rounded-full shadow-sm" />
                                    <h1>{member.user[0]?.userName}</h1>
                                </NavLink>
                                <div className='flex self-end justify-end'>
                                    {console.log(member?.user[0]?._id)}
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            // setRequestUserId(member?.user[0]?._id);
                                            acceptRequest(member?.user[0]?._id);
                                        }}
                                        className={`bg-green-500 text-white font-bold p-2 rounded-full w-auto outline-none`}
                                    >
                                        <IoIosCheckmark />
                                    </button>
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            // setRequestUserId(member?.user[0]?._id);
                                            denyRequest(member?.user[0]?._id);
                                        }}
                                        className={`bg-indigo-500 text-white font-bold p-2 rounded-full w-auto outline-none`}
                                    >
                                        <IoIosClose />
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                }


            </div>

        </div>
    );
};

export default FamilyDetails;
